import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchService, updateService } from "../../redux/Slice/serviceslice";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import CustomTable from "../../components/table/Table";

const columns = [
  { id: "servNo", label: "Service No", minWidth: 50, align: "start" },
  { id: "service_name", label: "Service Name", minWidth: 150, align: "start" },
  { id: "status", label: "Status", minWidth: 150, align: "center" },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center",
    actionType: [{ edit: true, view: true }],
  },
];

export const ServiceInactive = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { services, totalPages } = useSelector((state) => state.service);

  const transformService = (services) =>
    services
      .filter((service) => !service.status) 
      .map((service) => ({
        _id: service._id,
        servNo: service.serv_id,
        service_name: service.name || "N/A",
        status: service.status ? true : false,
        action: "",
      }));

  const modifiedRows = services ? transformService(services) : [];

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchService({ page: page, limit: rowsPerPage, searchTerm }))
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  }, [dispatch, page, rowsPerPage, searchTerm]);

  const handleStatusChange = (row) => {
    if (typeof row.status !== 'boolean') {
      console.error("Invalid type for row.status. It must be a boolean.");
    }
      const updatedStatus = !row.status;
    console.log("bool:",updatedStatus);
    
    dispatch(setLoading(true));

    dispatch(updateService({ id: row._id, formData: { status: updatedStatus } }))
      .unwrap()
      .then(() => {
        toast.success("Service status updated successfully!");
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
        toast.error("Failed to update status. Please try again.");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const handleView = (row) => {
    console.log("View service details", row);
  };

  const handleEdit = () => {
    console.log("Edit service");
  };

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Inactive Services{" "}
          <Typography component="span">({modifiedRows.length})</Typography>
        </Typography>
      </Box>

      <CustomTable
        columns={columns}
        rows={modifiedRows}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalPages={totalPages}
        handleEdit={handleEdit}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
      />
    </div>
  );
};
